module.exports = __webpack_public_path__ + "static/media/order-icon.862ded41.svg";